import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";

const CustomModal = ({
  headerTitle,
  bodyText,
  onToggle,
  CustomButton,
  FormButton,
  handleSubmit,
  onClick,
  noBtn,
  onlyBtn,
  footerTemplate,
  ...rest
}) => {
  return (
    <Modal {...rest} toggle={onToggle} backdrop="static">
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={onToggle}>{headerTitle}</ModalHeader>
        <ModalBody>{bodyText}</ModalBody>
        {footerTemplate ? (
          footerTemplate()
        ) : (
          <ModalFooter>
            {!noBtn && (FormButton || <CustomButton onClick={onClick} />)}{" "}
            {!onlyBtn && (
              <Button color="secondary" onClick={onToggle}>
                Fechar
              </Button>
            )}
          </ModalFooter>
        )}
      </Form>
    </Modal>
  );
};

export default CustomModal;
